import { Map } from 'immutable';

import * as t from './actionTypes';

const initialState = Map({
  audioGenerationQueueData: null,
  abbreviationsQueueData: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case t.SET_AUDIO_GENERATION_QUEUE_STATS:
      return state.set(
        'audioGenerationQueueData',
        action.audioGenerationQueueData,
      );
    case t.SET_ABBREVIATIONS_QUEUE_STATS:
      return state.set('abbreviationsQueueData', action.abbreviationsQueueData);
    default:
      return state;
  }
};
